import { Trans, useTranslation } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

export default function IdeaVotedContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  const { t } = useTranslation();
  const textSuffix =
    events[0]?.isFollower ?
      `${t("generic.ideaWithArticle")} you follow`
    : `your ${t("generic.idea")}`;

  return (
    <Trans
      i18nKey="notifications.ideaVoted"
      values={{
        name: util.getEventNames(events ?? []),
        suffix: textSuffix,
        idea: ownerIdea?.name || "Unknown",
      }}
    />
  );
}
